import React, { Fragment } from 'react';
import { getOneCategoryMovie } from '../../graphqlDic';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import CategoryItemsComponent from '../../components/TVShow/CategoryItemsComponent';
import { TVSHOW } from '../../constants/TypesCategory';
import { LIMIT_ITEMS_MEDIA } from '../../constants/Common';

class ShowCategoryItems extends React.Component {

    render() {
        if (this.props.getOneCategoryMovie.loading) return "Loading...";
        if (this.props.getOneCategoryMovie.error) return `Error! ${this.props.getOneCategoryMovie.error.message}`;
        let category = this.props.getOneCategoryMovie.getOneCategoryMovie;
        return (
            <Fragment>
                <CategoryItemsComponent categoryData = {category} />
            </Fragment>
        );
    }
}

export default compose(
    graphql(getOneCategoryMovie, {
        name: 'getOneCategoryMovie',
        options: (ownProps) => ({
            variables: {
                type: TVSHOW,
                _id: ownProps.location.state.item_id,
                first: LIMIT_ITEMS_MEDIA,
                after: '',
                after_hot: ''
            }
        })
    })
)(withRouter(
    connect(
        null
    )(ShowCategoryItems)
)
);


// WEBPACK FOOTER //
// ./src/containers/TVShow/ShowCategoryItems.js